import { displayPlaceName, ROUTE_LANDING_PAGES } from './routeLanding';
import { LOCAL_CORRIDOR_PAGES } from './localCorridorPages';

const DEDICATED_ROUTE_PAGES = [
  {
    slug: '/chennai-to-madurai-taxi',
    origin: 'Chennai',
    destination: 'Madurai',
    displayOrigin: 'Chennai',
    displayDestination: 'Madurai',
  },
  {
    slug: '/madurai-to-chennai-taxi',
    origin: 'Madurai',
    destination: 'Chennai',
    displayOrigin: 'Madurai',
    displayDestination: 'Chennai',
  },
  {
    slug: '/coimbatore-to-ooty',
    origin: 'Coimbatore',
    destination: 'Ooty',
    displayOrigin: 'Coimbatore',
    displayDestination: 'Ooty',
  },
  {
    slug: '/ooty-to-coimbatore',
    origin: 'Ooty',
    destination: 'Coimbatore',
    displayOrigin: 'Ooty',
    displayDestination: 'Coimbatore',
  },
  {
    slug: '/coimbatore-to-cochin-airport',
    origin: 'Coimbatore',
    destination: 'Cochin International Airport',
    displayOrigin: 'Coimbatore',
    displayDestination: 'Cochin International Airport',
  },
  {
    slug: '/cochin-airport-to-coimbatore',
    origin: 'Cochin International Airport',
    destination: 'Coimbatore',
    displayOrigin: 'Cochin International Airport',
    displayDestination: 'Coimbatore',
  },
];

const DIRECTORY_CITIES = [
  { id: 'coimbatore', name: 'Coimbatore', heading: 'Coimbatore Taxi Routes' },
  { id: 'chennai', name: 'Chennai', heading: 'Chennai Taxi Routes' },
  { id: 'madurai', name: 'Madurai', heading: 'Madurai Taxi Routes' },
  { id: 'trichy', name: 'Trichy', heading: 'Trichy Taxi Routes' },
  { id: 'bangalore', name: 'Bangalore', heading: 'Bangalore Taxi Routes' },
  { id: 'salem', name: 'Salem', heading: 'Salem Taxi Routes' },
];

const toEntry = (page) => ({
  path: page.slug,
  origin: page.displayOrigin || displayPlaceName(page.origin),
  destination: page.displayDestination || displayPlaceName(page.destination),
});

const allRegisteredRoutePages = () => {
  const byPath = new Map();
  [...ROUTE_LANDING_PAGES, ...DEDICATED_ROUTE_PAGES, ...LOCAL_CORRIDOR_PAGES].forEach((page) => {
    if (page?.slug && !byPath.has(page.slug)) {
      byPath.set(page.slug, toEntry(page));
    }
  });
  return [...byPath.values()];
};

const matchesCity = (place, cityName) => (
  displayPlaceName(place) === cityName || String(place) === cityName
);

const sortEntries = (entries) => [...entries].sort((a, b) => {
  const aLabel = `${a.origin} ${a.destination}`;
  const bLabel = `${b.origin} ${b.destination}`;
  return aLabel.localeCompare(bLabel);
});

export const getTaxiRouteDirectory = () => {
  const routes = allRegisteredRoutePages();

  const groups = DIRECTORY_CITIES.map((city) => {
    const outbound = routes.filter((route) => matchesCity(route.origin, city.name));
    const inbound = routes.filter((route) => (
      matchesCity(route.destination, city.name) && !matchesCity(route.origin, city.name)
    ));

    return {
      id: city.id,
      heading: city.heading,
      routes: [...sortEntries(outbound), ...sortEntries(inbound)],
    };
  }).filter((group) => group.routes.length > 0);

  return {
    groups,
    uniqueCount: routes.length,
    uniquePaths: routes.map((route) => route.path),
  };
};
